import Delegate from 'ftdomdelegate'
import fastdom from 'fastdom'

import Accessibility from '../tools/accessibility'

export default class Modal {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.activeModal = null; // Keep track of the active modal
    this.wasLocked = false;

    this.pageOverlayElement = document.querySelector('.pageOverlay');

    this._attachListeners();
    this._checkOpenByHash();
  }

  _attachListeners() {
    this._closeListener = this._closeModal.bind(this);
    this._handleKeyboardListener = this._handleKeyboard.bind(this);

    this.domDelegate.on('click', '[data-action="open-modal"]', this._openModalEvent.bind(this));
    this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this));
  }
  _openModalEvent(event, target) {
    this._openModal(document.getElementById(target.getAttribute('aria-controls')));
    event.preventDefault();
    event.stopPropagation();
  }
  _openModal(modal) {
    var _this15 = this;

    if (this.activeModal || !modal) {
      return; // If there is already an open modal, we return as we only allows one modal at a time
    }

    this.activeModal = modal;
    this.domDelegate.on('keyup', this._handleKeyboardListener);

    if (document.documentElement.classList.contains('no-scroll')) {
      this.wasLocked = true;
    }

    fastdom.mutate(function () {
      Accessibility.clearTrapFocus(); // Needed as the modal can be open on top of a popover

      _this15._onTransitionEndedListener = _this15._onTransitionEnded.bind(_this15);
      _this15.activeModal.addEventListener('transitionend', _this15._onTransitionEndedListener);

      _this15.activeModal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');

      // If the modal is not a fullscreen modal, then we also display the overlay
      if (!_this15.activeModal.classList.contains('modal--fullScreen')) {
        _this15.pageOverlayElement.classList.add('is-visible');
        _this15.pageOverlayElement.addEventListener('click', _this15._closeListener);
      }
    });
  }
  _closeModal() {
    var _this16 = this;

    if (!this.activeModal) {
      return; // If no modal are open, we return immediately
    }

    this.activeModal.removeEventListener('keyup', this._handleKeyboardListener);
    this.domDelegate.off('keyup');

    fastdom.mutate(function () {
      // If the modal is of video type, we need to remove the iframe to stop the video
      if (_this16.activeModal.classList.contains('modal--videoContent')) {
        _this16._resetVideoListener = _this16._resetVideo.bind(_this16);
        _this16.activeModal.addEventListener('transitionend', _this16._resetVideoListener);
      }

      Accessibility.removeTrapFocus(_this16.activeModal, 'modal');

      if (!_this16.activeModal.classList.contains('modal--fullScreen')) {
        _this16.pageOverlayElement.classList.remove('is-visible');
        _this16.pageOverlayElement.removeEventListener('click', _this16._closeListener);
      }

      _this16.activeModal.setAttribute('aria-hidden', 'true');
      _this16.activeModal = null;

      if (!_this16.wasLocked) {
        document.documentElement.classList.remove('no-scroll');
      }
    });
  }
  _onTransitionEnded(event) {
    if (event.propertyName !== 'visibility') {
      return;
    }

    Accessibility.trapFocus(this.activeModal, 'modal'); // Trap the focus first (as this trigger reflows)

    this.activeModal.removeEventListener('transitionend', this._onTransitionEndedListener);
  }
  _resetVideo(event) {
    if (event.propertyName !== 'visibility') {
      return; // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
    }

    var iframe = event.target.querySelector('iframe');
    iframe.parentNode.innerHTML = '<iframe class="image--lazyLoad" data-src=' + iframe.getAttribute('data-src') + ' frameborder="0" allowfullscreen>';

    event.target.removeEventListener('transitionend', this._resetVideoListener);
  }

  /**
   * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
   */

  _checkOpenByHash() {
    var hash = window.location.hash,
        modal = document.getElementById(hash.replace('#', ''));

    if (modal && modal.classList.contains('modal')) {
      this._openModal(modal);
    }
  }

  /**
   * Handle a11y events
   */

  _handleKeyboard(event) {
    if (null !== this.activeModal && event.keyCode === 27) {
      this._closeModal();
    }
  }
}